window.PureGym = (function ($, components) {
    window.dataLayer = window.dataLayer || [];
    const self = {
        ids: {
            puregymSignupForm: '#puregym-form'
        },
        gtm: {
            event: {
                rewardSignUp: 'rewardSignUp'
            }
        },
        func: {
            init: function () {
                self.func.bind();
            },
            bind: function () {
                $(components.ComplianceInformation.Elements.Buttons.SignUpButton).on('click', self.func.handlePartnerRedirect);
            },
            handlePartnerRedirect: function () {
                window.dataLayer.push({event: self.gtm.event.rewardSignUp});
                if ($(self.ids.puregymSignupForm).attr('action')) {
                    $(self.ids.puregymSignupForm).submit();
                }
            }
        }
    };

    return {
        init: self.func.init
    };
})(window.jQuery, { ComplianceInformation: window.ComplianceInformation, Utilities: window.Utilities });

$('document').ready(function () {
    if (window.Utilities.func.isPartnerSignupPage('PureGym')) {
        window.PureGym.init();
    }
});
